import { render, staticRenderFns } from "./CopyStakeJackpotCampaignDialogMainForm.vue?vue&type=template&id=1eacb6d9&scoped=true&lang=pug"
import script from "./CopyStakeJackpotCampaignDialogMainForm.vue?vue&type=script&lang=ts"
export * from "./CopyStakeJackpotCampaignDialogMainForm.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeJackpotCampaignDialogMainForm.vue?vue&type=style&index=0&id=1eacb6d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eacb6d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSwitch,VTextField})
